var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"minimap",staticClass:"workflow-overview",style:({ '--workflow-overview-size': `${_setup.minimapSize + _setup.size.padding + _setup.size.border}px` })},[_c('canvas',{ref:"canvas",staticClass:"workflow-overview-body",attrs:{"width":_setup.size.max,"height":_setup.size.max}})])
}
var staticRenderFns = []

export { render, staticRenderFns }